var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.33333C4.31811 1.33333 1.33333 4.31811 1.33333 8C1.33333 11.6819 4.31811 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.31811 11.6819 1.33333 8 1.33333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#9ACA3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 10.6665C8.36852 10.6665 8.66699 10.9649 8.66699 11.3332C8.66699 11.7014 8.36852 11.9998 8.00033 11.9998C7.63214 11.9998 7.33366 11.7014 7.33366 11.3332C7.33366 10.9649 7.63214 10.6665 8.00033 10.6665Z",
    fill: "#9ACA3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4C6.89543 4 6 4.89543 6 6C6 6.36819 5.70152 6.66667 5.33333 6.66667C4.96514 6.66667 4.66667 6.36819 4.66667 6C4.66667 4.15905 6.15905 2.66667 8 2.66667C9.84095 2.66667 11.3333 4.15905 11.3333 6C11.3333 7.26623 10.6269 8.36908 9.58541 8.93333C9.19056 9.14712 8.66667 9.50177 8.66667 10C8.66667 10.3682 8.36819 10.6667 8 10.6667C7.63181 10.6667 7.33333 10.3682 7.33333 10C7.33333 8.73377 8.14278 8.01759 8.91459 7.6C9.56644 7.24702 10 6.67044 10 6C10 4.89543 9.10457 4 8 4Z",
    fill: "#9ACA3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.85b0f35e42c129640dba064e8df8ba48.svg";
export { ForwardRef as ReactComponent };